module.exports = __webpack_public_path__ + "static/media/carro_1.0d7ec052.png";